import { useQuery } from "react-query";
import { MasterSheetAPI } from "api/admin/masterSheet";
import { MASTER_SHEET } from "helpers/constants";

export default function useMasterSheet() {
  return useQuery(MASTER_SHEET, MasterSheetAPI.get);
}
